const COOKIE_MAX_AGE = 60 * 60 * 24 * 30

export const setWeischerCookie = () => {
    const mainDomain = pmkinoFrontVars && pmkinoFrontVars.cinemaData.main_domain
    const siteDomain = pmkinoFrontVars && pmkinoFrontVars.cinemaData.site.url_site

    if(siteDomain && mainDomain) {
        const secure = window.location.protocol === 'https:' ? "; Secure" : ""

        document.cookie = "last_visited=" + siteDomain
            + "; domain=" + mainDomain
            + "; path=/"
            + "; max-age=" + COOKIE_MAX_AGE
            + "; SameSite=Lax"
            + secure
    }
}